import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from '../../models/state';
import { ApiService } from '../api.service';
import { NavService } from '../nav.service';
import { StateService } from '../state.service';

@Injectable({
  providedIn: 'root'
})
export class ApiHelperService {

  constructor(
    private api: ApiService,
    private dialog: MatDialog,
    private stateService: StateService,
    private nav: NavService
  ) { }

  async setSearchEngineList(state: Partial<AppState>) {

    const codGuia = state.codGuia;
    const searchEngineListArray = await this.api.getSearchEngineList();
    let searchEngineList;
    if (codGuia) {
      searchEngineList = searchEngineListArray.buscadoresPorGuiaMedica
        .find(ele => ele.codigoGuiaMedica === codGuia);
    }

    if (!codGuia) {
      searchEngineList = searchEngineListArray.buscadoresPorGuiaMedica
        .find(ele => ele.codigoGuiaMedica === 'NINGUNA');
    }

    if (!searchEngineList) {
      searchEngineList = searchEngineListArray.buscadoresPorGuiaMedica
        .find(ele => ele.codigoGuiaMedica === 'TODAS');
    }

    let searchEngineListId = searchEngineList?.listaBuscadores?.map(id => id);

    this.api.getSearchEngine(searchEngineListId, state).subscribe(searchEngineList => {
      state.searchEngineList = searchEngineList;
      this.searchEngineHandler(searchEngineList, state);
    });
  }

  getMedicalGuides(state: Partial<AppState>, closeModal = true) {
    if (state.medicalGuides) return;
    this.api.getMedicalGuides().subscribe(medicalGuides => {
      if (closeModal) this.dialog.closeAll();
      this.stateService.updateState({
        ...state,
        medicalGuides
      });
    });
  }

  private searchEngineHandler(searchEngineList, state: Partial<AppState>): void {
    if (!searchEngineList || searchEngineList?.length === 0) {
      //TODO: pantalla error
      console.error('No hay buscadores');
      return;
    }

    if (state?.healthPolicies && state?.healthPolicies.length > 1) {
      this.stateService.updateState(state);
      return;
    }


    if (searchEngineList?.length === 1) {
      this.stateService.updateState(state);
      this.nav.navTo(searchEngineList[0].url);
      this.dialog.closeAll();
      return;
    }

    this.stateService.updateState(state);
  }
}
